export default theme => ({
  root: {
    flexGrow: 1,
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    margin: "0 auto",
    overflowX: "hidden",
    padding: "24px",
    [theme.breakpoints.up("lg")]: {
      width: "70%",
    },
  },
  nameField: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  copperTitle: {
    fontSize: 16,
    fontWeight: "bold",
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  fiberTitle: {
    fontSize: 16,
    fontWeight: "bold",
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  minPerfTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  buttons: {
    display: "flex",
    gap: '8px',
    justifyContent: 'flex-end',
    marginTop: '32px',
  },
  confirmDialog: {
    marginTop: theme.spacing.unit * 2,
    padding: theme.spacing.unit * 2,
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: 4,
    backgroundColor: theme.palette.error.light,
  },
  loadError: {
    marginTop: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 3,
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: 4,
    backgroundColor: theme.palette.error.light,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.unit * 2,
    maxWidth: 640,
  },
  firstColumn: {
    display: 'flex',
    height: '45px',
  },
  numberField: {
    width: '85px',
    '& .react-aria-Label': {
      display: 'none',
    },
  },
  defaultValue: {
    display: 'flex',
    alignItems: 'center',
  },
  unit: {
    marginLeft: theme.spacing.unit,
  },
  jumper: {
    marginLeft: theme.spacing.unit,
  },
  errorText: {
    fontSize: 12,
    color: '#e34850',
    marginTop: 4,
  },
});
